// import { useRoute } from 'vue-router'
import layoutConfig from '@/config'
import textConfig from '@/config/textConfig'
import { readonly, ref } from 'vue'

// const config = ref(null)
// const text

const currLayout = ref(null)
const currText = ref(null)
// let initialized = false
export function useLayoutConfig() {
  function setTheme(brand) {
    currLayout.value = layoutConfig?.[brand]
    currText.value = textConfig?.[brand]

    // const styleProperties = {
    //   '--bg-body': currLayout.value?.body?.background,
    //   '--color-body': currLayout.value?.body?.color,
    // }
    document.body.className = '' // 清空
    document.body.classList.add(brand)

    // Object.entries(styleProperties).forEach(([key, val]) => {
    //   if (val) {
    //     document.body.style.setProperty(key, val)
    //   }
    // })

    const favIcon = currLayout.value?.favIcon
    if (favIcon) {
      const link = document.querySelector("link[rel*='icon']")
      link.href = favIcon
    }
    const title = currText.value?.title
    if (title) {
      document.title = title
    }

    return {
      config: readonly(currLayout),
      text: readonly(currText),
    }
  }

  return {
    config: readonly(currLayout),
    text: readonly(currText),
    setTheme,
  }
}
